import { useContext } from 'react'

import { isNil } from 'ramda'

import { ModalContext } from './modal-context'

// Hook which will return true if the component is rendered inside a modal
export const useIsInModal = (): boolean => {
  const context = useContext(ModalContext)

  // if we don't have a context, we are not in a modal
  if (isNil(context)) {
    return false
  }

  return context.isInModal
}
